
<form [formGroup]="dannoBiologicoForm" (ngSubmit)="save();" *ngIf="viewForm">

  <div class="row">
    <div textInput [control]="dannoBiologicoForm.controls['patologia']"
      class="col-sm-4" [labelInput]="'Patologia'"
      formControlName="patologia"
      [(ngModel)]="dannoBiologico.patologia" [mandatory]="true"></div>
    <div datePickerInput class="col-sm-4" [labelInput]="'Data diagnosi'"
      formControlName="dataDiagnosi"
      [control]="dannoBiologicoForm.controls['dataDiagnosi']"
      [(ngModel)]="dannoBiologico.dataDiagnosi"
      [mandatory]="true"></div>

      <div datePickerInput class="col-sm-4" [labelInput]="'Data decesso'"
        formControlName="dataDecesso"
        [control]="dannoBiologicoForm.controls['dataDecesso']"
        [(ngModel)]="dannoBiologico.dataDecesso"
        [mandatory]="false"></div>
  </div>

  <div class="row">
    <div checkBoxRadio class="col-sm-4"
      [mandatory]="true"
      [labelInput]="'Riconoscimento malattia professionale'"
      formControlName="riconoscimentoMalattiaProfessionale" [objectReference]="dannoBiologico.riconoscimentoMalattiaProfessionale"
      (onReturn)="dannoBiologico.riconoscimentoMalattiaProfessionale = $event; dannoBiologicoForm.controls['riconoscimentoMalattiaProfessionale'].setValue($event); cambioValidita($event)"></div>

      <div datePickerInput class="col-sm-4" [labelInput]="'Data riconoscimento'"
        formControlName="dataRiconoscimentoMalattiaProfessionale" 
        [control]="dannoBiologicoForm.controls['dataRiconoscimentoMalattiaProfessionale']"
        [(ngModel)]="dannoBiologico.dataRiconoscimentoMalattiaProfessionale"
        [mandatory]="dannoBiologico.riconoscimentoMalattiaProfessionale"></div>

      <div textInputCurrency class="col-sm-4" [control]="dannoBiologicoForm.controls['percentualeInvalidita']"
        [labelInput]="'% invalidità'" [maxValue]="100" [isNaturalNumber]="true"
        formControlName="percentualeInvalidita"  [location]="'SezioneEconomica'"
        [(ngModel)]="dannoBiologico.percentualeInvalidita"></div>
  </div>

  <div class="row">
    <div datePickerInput class="col-sm-4" [labelInput]="'Data rilevazione invalidità temporanea'"
      formControlName="dataRilevazioneInvaliditaTemp" 
      [control]="dannoBiologicoForm.controls['dataRilevazioneInvaliditaTemp']"
      [(ngModel)]="dannoBiologico.dataRilevazioneInvaliditaTemp"
      [mandatory]="false"></div>

    <div textInputCurrency class="col-sm-4" [control]="dannoBiologicoForm.controls['importoInvaliditaTemp']"
      [labelInput]="'Importo invalidità temporanea'" [location]="'SezioneEconomica'" [mandatory]="false"
      formControlName="importoInvaliditaTemp" [(ngModel)]="dannoBiologico.importoInvaliditaTemp"></div>

    <div textInputCurrency class="col-sm-4" [control]="dannoBiologicoForm.controls['percentualeAbbattimento']"
      [labelInput]="'% di abbattimento'"  [maxValue]="100" [location]="'SezioneEconomica'" [mandatory]="false"
      formControlName="percentualeAbbattimento" [isNaturalNumber]="true" [(ngModel)]="dannoBiologico.percentualeAbbattimento"></div>

  </div>

  <div class="row">
    <div textInputCurrency class="col-sm-4" [control]="dannoBiologicoForm.controls['importoDannoBiologico']"
      [labelInput]="'Danno biologico'"  [location]="'SezioneEconomica'" [mandatory]="false"
      formControlName="importoDannoBiologico" [(ngModel)]="dannoBiologico.importoDannoBiologico"></div>

    <div textInputCurrency class="col-sm-4" [control]="dannoBiologicoForm.controls['dannoMorale']"
      [labelInput]="'Danno morale'"  [location]="'SezioneEconomica'" [mandatory]="false"
      formControlName="importoDannoMorale" [(ngModel)]="dannoBiologico.importoDannoMorale"></div>

    <div textInputCurrency class="col-sm-4" [control]="dannoBiologicoForm.controls['importoDannoMoraleEredi']"
      [labelInput]="'Danno morale eredi/congiunti'"  [location]="'SezioneEconomica'" [mandatory]="false"
      formControlName="importoDannoMoraleEredi" [(ngModel)]="dannoBiologico.importoDannoMoraleEredi"></div>
  </div>

  <div class="row">
    <div textAreaInput class="form-group col-xs-12 col-sm-12"
         [labelInput]="'Note'" formControlName="note"
         [(ngModel)]="dannoBiologico.note"></div>
  </div>
  <div class="row">
    <p class="col-md-12 mandatory">
      <em>* Campi obbligatori</em>
    </p>
  </div>

  <div class="row">
    <p class="col-sm-3 col-xs-6">
      <button type="button" class="btn btn-outline-secondary btn-block"
              (click)="reset()">Reset</button>
    </p>
    <p submitButton	class="col-sm-3 col-xs-6 col-sm-offset-6"
       [labelButton]="'Salva'" [disabled]="!dannoBiologicoForm.valid"></p>
  </div>
</form>
